module.exports = __webpack_public_path__ + "static/7-fddfedeec5a1ed5f16a06bea3b8b21b1.jpg";